import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { successToast } from "components/toast";
import { errorToast } from "components/toast";
import { useNavigate, useParams } from "react-router-dom";
import { createFaqData } from "services/_faq";
import { getFaqDataById } from "services/_faq";
import { updateFaqDataById } from "services/_faq";

const CreateFaq = () => {
  const { id } = useParams();
  const [editData, setEditData] = useState({});
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/admin/faq");
  };

  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      question: values.question,
      status: values.status,
      answer: values.answer,
    };

    if (id) {
      const data = await updateFaqDataById(id, payload);
      if (data.data) {
        successToast(data.message);
      } else {
        errorToast(data.message);
      }
      navigate("/admin/faq");
    } else {
      const data = await createFaqData(payload);
      if (data.data) {
        successToast(data.message);
        resetForm();
        navigate("/admin/faq");
      } else {
        errorToast(data.message);
      }
    }
  };

  const getInitialData = useCallback(async () => {
    const data = await getFaqDataById(id);
    if (data.data) {
      setEditData(data.data);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      getInitialData();
    }
  }, [getInitialData, id]);

  const MedicalConditionSchema = Yup.object().shape({
    question: Yup.string().required("Name is required"),
    status: Yup.boolean().nullable(),
    answer: Yup.string().required("Answer is required"),
  });

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">
                      <i
                        className="fas fa-arrow-left"
                        style={{ paddingRight: "10px" }}
                        onClick={handleNavigate}
                      ></i>
                      {id ? "Edit Faq" : "Create Faq "}
                    </h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    question: editData?.question || "",
                    status: editData?.status ?? null,
                    answer: editData?.answer || "",
                  }}
                  validationSchema={MedicalConditionSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, setFieldValue, handleChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="pl-lg-4">
                        <Row>
                          {/* Name */}
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-question"
                              >
                                Question <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-question"
                                name="question"
                                placeholder="Enter Question"
                                type="text"
                                value={values.question}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="question"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>

                          {/* Short Description */}
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-status"
                              >
                                Status
                              </label>
                              <Input
                                type="select"
                                id="input-status"
                                name="status"
                                className="form-control-alternative"
                                style={{
                                  boxShadow:
                                    "0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)",
                                  border: 0,
                                  color: "#90a4ae !important",
                                }}
                                value={
                                  values.status === true
                                    ? "true"
                                    : values.status === false
                                    ? "false"
                                    : ""
                                }
                                onChange={(e) =>
                                  setFieldValue(
                                    "status",
                                    e.target.value === "true" ? true : false
                                  )
                                }
                              >
                                <option value="">Select status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </Input>
                              <ErrorMessage
                                name="status"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-name"
                              >
                                Answer
                                <span style={{ color: "red" }}> *</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                name="answer"
                                placeholder="Enter Detailed Answer"
                                rows="6"
                                type="textarea"
                                value={values.answer}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="answer"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      <div className="pl-lg-4">
                        <Button color="primary" type="submit">
                          Save
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateFaq;
